
import { Options, Vue } from 'vue-class-component'
import { Prop, PropSync } from 'vue-property-decorator'
import OCRComponent from '@/components/OCRComponent.vue'
import ScanComponent from '@/components/ScanComponent.vue'
import { EBCRType, ECameraReaderType, EOCRType } from '@/utils/enums'
@Options({
  name: 'ActionDialog',
  emits: ['update:isShowActionDialog', 'update:confirm'],
  components: {
    OCRComponent,
    ScanComponent,
  },
})
export default class ActionDialog extends Vue {
  @Prop({ type: String }) readonly label?: string
  @PropSync('isShowActionDialog', { type: Boolean }) syncedModel?: boolean
  @Prop({ default: ECameraReaderType.BCR }) actionType!: ECameraReaderType
  @Prop({ default: EOCRType.DEFAULT }) ocrReaderType!: EOCRType
  @Prop({ type: String }) readonly fieldName!: string
  @Prop({ default: EBCRType.DEFAULT }) customBarcodeReaderType!: EBCRType // This will override barcodeReaderType from mixins
  @Prop({ type: [String, Number] }) readonly initialValue?: string | number
  @Prop({ type: Boolean }) readonly isShowMultipleScan?: boolean

  onDialogClosing() {
    this.syncedModel = false
    // if (this.$refs?.ocrComponent) this.$refs.ocrComponent.vidOff()
  }

  confirmText(text: string) {
    this.$emit('update:confirm', text.trim())
  }

  get component() {
    switch (this.actionType) {
      case ECameraReaderType.BCR:
        return {
          item: ScanComponent,
          props: {
            fieldName: this.fieldName,
            customBarcodECameraReaderType: this.customBarcodeReaderType,
            initialValue: this.initialValue,
            isShowMultipleScanData: this.isShowMultipleScan,
          },
        }
      case ECameraReaderType.OCR:
        return {
          item: OCRComponent,
          props: {
            fieldName: this.fieldName,
            initialValue: this.initialValue,
            isShowMultipleScanData: this.isShowMultipleScan,
          },
        }
      default:
        return {
          item: ScanComponent,
          props: {
            fieldName: this.fieldName,
            customBarcodECameraReaderType: this.customBarcodeReaderType,
            initialValue: this.initialValue,
            isShowMultipleScanData: this.isShowMultipleScan,
          },
        }
    }
  }
}
